"use strict";
export { Spinner, SpinnerPropsProvider } from './spinner.js';
